'use strict';

typeof window !== 'undefined' && (() => {
  require('./assets/cookie-notification.css');
  const utils = require('./utils/utils');
  const tsStart = new Date().getTime();
  let cookieNotificationInited = false;
  utils.reportBI('506');

  function cookieNotification() {
    if (cookieNotificationInited) {
      return;
    }
    cookieNotificationInited = true;
    utils.reportBI('509');
    const userDetails = require('modules/userDetails');
    const geoValidator = require('modules/geoValidator');
    const visual = require('modules/visual');
    const locale = require('modules/locale');
    const language = userDetails.language();

    if (userDetails.sawNotification()) {
      utils.reportBI('508', ['required=0', 'reason=approved']);
      return;
    }

    if (!userDetails.isAnonymous()) {
      utils.reportBI('508', ['required=0', 'reason=logged-in']);
      return;
    }

    geoValidator.validate()
      .then(result => {
        if (!result.data.allowed) {
          utils.reportBI('508', ['required=0', 'reason=NON EU']);
          return;
        }

        utils.reportBI('508', ['required=1']);
        utils.reportBI('510');
        const ts = new Date().getTime();
        const device = result.data.device !== undefined ? result.data.device : 'desktop';
        const data = {language, locale: locale.get(language), device};
        visual.create(data, ts);
      })
      .catch(error => console.warn(error));
  }

  if (document.readyState === 'complete') {
    cookieNotification();
  } else {
    window.addEventListener('load', cookieNotification);
  }

  cookieNotification();
  utils.reportBI('507', [`delta=${new Date().getTime() - tsStart}`]);
})();



// WEBPACK FOOTER //
// ./client.js